import rootLogger from '@/utils/root-logger';
import fetcher from '@/utils/fetcher';

const logger = rootLogger.create('vuex-modules/g2w-session/me');

const mutations = {
  setRegistrantDetails(state, payload) {
    state.registrantDetails = payload.registrantDetails;
  },

  setSessionAttendeeKey(state, payload) {
    state.sessionAttendeeKey = payload.sessionAttendeeKey;
  },

  setParticipant(state, payload) {
    state.participant = Object.assign({}, state.participant, payload.participant);
  },

  setAttendanceRecordStatus(state, payload) {
    state.attendanceRecordStatus = payload.attendanceRecordStatus;
  },

  setAudio(state, payload) {
    state.audio = Object.assign({}, state.audio, payload.audio);
  }
};

const actions = {
  async getRegistrantDetails({commit, rootState, rootGetters}) {
    const operation = 'getRegistrantDetails';
    const webinarKey = rootState.g2wSession.joinInfo.webinarKey;
    const email = rootState.g2wSession.joinInfo.participant.email;
    logger.log(operation, {webinarKey, email});

    const path = `/api/webinars/${webinarKey}/registrants?email=${email}`;
    const url = rootGetters['g2wEnv/globalUrl'](path);

    const registrantDetails = await fetcher.fetchJSON(url, {}, {operation});
    commit('setRegistrantDetails', {registrantDetails});
    return registrantDetails;
  },

  async registerMachineId({
    commit, state, rootState, rootGetters, dispatch
  }) {
    const operation = 'registerMachineId';
    const webinarKey = rootState.g2wSession.joinInfo.webinarKey;

    let attendeeId = state.registrantDetails && state.registrantDetails.attendeeId;
    if (!attendeeId) {
      const registrantDetails = await dispatch('getRegistrantDetails');
      attendeeId = registrantDetails.attendeeId;
    }

    const machineId = rootState.g2wEnv.machineId;

    logger.log(operation, {webinarKey, attendeeId, machineId});

    const path = `/api/webinars/${webinarKey}/attendees/${attendeeId}/machines/${machineId}`;
    const url = rootGetters['g2wEnv/globalUrl'](path);

    const fetchParams = {
      method: 'PUT'
    };

    const result = await fetcher.fetchJSON(url, fetchParams, {operation});

    commit('setSessionAttendeeKey', {sessionAttendeeKey: result.sessionAttendeeKey});

    return result;
  },

  async recordAttendance({
    commit, state, rootState, rootGetters
  }) {
    logger.log('recordAttendance', {attendanceRecordStatus: state.attendanceRecordStatus});

    if (state.attendanceRecordStatus === 'recording'
        || state.attendanceRecordStatus === 'recorded') {
      return;
    }

    commit('setAttendanceRecordStatus', {attendanceRecordStatus: 'recording'});

    const operation = 'recordAttendance';
    const webinarKey = rootState.g2wSession.joinInfo.webinarKey;
    const {name, email, id: participantId} = state.participant || {};
    const machineId = rootState.g2wEnv.machineId;

    const path = `/api/webinars/${webinarKey}/attendees`;
    const url = rootGetters['g2wEnv/globalUrl'](path);

    const fetchParams = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        participantId, name, email, machineId
      })
    };

    try {
      await fetcher.fetchText(url, fetchParams, {operation});
      commit('setAttendanceRecordStatus', {attendanceRecordStatus: 'recorded'});
    } catch (error) {
      logger.log('recordAttendance failure', {error});
      commit('setAttendanceRecordStatus', {attendanceRecordStatus: ''});
    }
  }
};

const state = () => ({
  registrantDetails: null,
  sessionAttendeeKey: '',
  participant: null,
  attendanceRecordStatus: false,
  audio: null
});

export default {
  namespaced: true,
  mutations,
  actions,
  state
};
